import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal, Button } from 'react-bootstrap';

const BulkSms = () => {
  const [selectedRole, setSelectedRole] = useState('');
  const [selectedClass, setSelectedClass] = useState('');
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [removedUsers, setRemovedUsers] = useState([]);
  const [message, setMessage] = useState('');
  const [date, setDate] = useState('');
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (selectedRole && selectedClass) {
      const users = getUsers(selectedRole, selectedClass);
      setSelectedUsers(users);
      setRemovedUsers([]);
    } else {
      setSelectedUsers([]);
      setRemovedUsers([]);
    }
  }, [selectedRole, selectedClass]);

  const getUsers = (role, className) => {
    if (role === 'teachers') {
      return ['Teacher 1', 'Teacher 2', 'Teacher 3', 'Teacher 4', 'Teacher 5', 'Teacher 6', 'Teacher 7', 'Teacher 8', 'Teacher 9'];
    } else if (role === 'students') {
      return ['Student 1', 'Student 2', 'Student 3', 'Student 4', 'Student 5', 'Student 6', 'Student 7', 'Student 8', 'Student 9'];
    }
    return [];
  };

  const handleRoleChange = (event) => {
    setSelectedRole(event.target.value);
    setSelectedClass('');
  };

  const handleClassChange = (event) => {
    setSelectedClass(event.target.value);
  };

  const handleUserRemove = (user) => {
    setSelectedUsers(selectedUsers.filter((u) => u !== user));
    setRemovedUsers([...removedUsers, user]);
  };

  const handleUserAdd = (user) => {
    setRemovedUsers(removedUsers.filter((u) => u !== user));
    setSelectedUsers([...selectedUsers, user]);
  };

  const handleMessageChange = (event) => {
    setMessage(event.target.value);
  };

  const handleDateChange = (event) => {
    setDate(event.target.value);
  };

  const handleSendSMS = () => {
    console.log('Role:', selectedRole);
    console.log('Class:', selectedClass);
    console.log('Users:', selectedUsers);
    console.log('Date:', date);
    console.log('Message:', message);
  };

  const chunkedUsers = [];
  for (let i = 0; i < selectedUsers.length; i += 6) {
    chunkedUsers.push(selectedUsers.slice(i, i + 6));
  }

  return (
    <div className="container-fluid mt-4">
      <h5>Bulk SMS</h5>

      <div className="row mt-4">
        <div className="col-md-4">
          <div className="form-group">
            <label htmlFor="roleSelect">Select Role:</label>
            <select
              id="roleSelect"
              className="form-control"
              value={selectedRole}
              onChange={handleRoleChange}
            >
              <option value="">Select Role</option>
              <option value="teachers">Teachers</option>
              <option value="students">Students</option>
            </select>
          </div>
        </div>
        <div className="col-md-4">
          {selectedRole && (
            <div className="form-group">
              <label htmlFor="classSelect">Select Class:</label>
              <select
                id="classSelect"
                className="form-control"
                value={selectedClass}
                onChange={handleClassChange}
              >
                <option value="">Select Class</option>
                {selectedRole === 'teachers' ? (
                  <>
                    <option value="classA">Class A</option>
                    <option value="classB">Class B</option>
                    <option value="classC">Class C</option>
                  </>
                ) : selectedRole === 'students' ? (
                  <>
                    <option value="classX">Class X</option>
                    <option value="classY">Class Y</option>
                    <option value="classZ">Class Z</option>
                  </>
                ) : null}
              </select>
            </div>
          )}
        </div>
        <div className="col-md-4">
          {selectedUsers.length > 0 && (
            <div className="form-group mt-2">
              <label htmlFor="date">Select Date:</label>
              <input
                type="date"
                id="date"
                className="form-control"
                value={date}
                onChange={handleDateChange}
              />
            </div>
          )}
        </div>
      </div>

      {selectedUsers.length > 0 && (
        <div className="mt-4">
          <h6>Selected Users:</h6>
          {chunkedUsers.map((userChunk, index) => (
            <div key={index} className="row mb-2">
              {userChunk.map((user, i) => (
                <div key={i} className="col-md-2">
                  <div className="card">
                    <div className="card-body d-flex justify-content-between align-items-center">
                      {user}
                      <button
                        type="button"
                        className="btn btn-danger btn-sm"
                        onClick={() => handleUserRemove(user)}
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      )}

      {removedUsers.length > 0 && (
        <Button variant="secondary" onClick={() => setShowModal(true)}>
          Add Users
        </Button>
      )}

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Add Users</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {removedUsers.map((user, index) => (
            <div key={index} className="d-flex justify-content-between align-items-center">
              {user}
              <Button variant="success" size="sm" onClick={() => handleUserAdd(user)}>
                Add
              </Button>
            </div>
          ))}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {date && (
        <div className="form-group mt-4">
          <label htmlFor="message">SMS Message:</label>
          <textarea
            id="message"
            className="form-control"
            rows="4"
            value={message}
            onChange={handleMessageChange}
          />
        </div>
      )}

      <button
        type="button"
        className="btn btn-primary mt-4"
        onClick={handleSendSMS}
        disabled={!selectedRole || !selectedClass || !selectedUsers.length || !date || !message}
      >
        Send SMS
      </button>
    </div>
  );
};

export default BulkSms;
